export default __webpack_public_path__ + "images/zippyy_weightDispute.svg";